import { useLazyQuery } from "@apollo/client";
import { gql } from "generated-graphql";
import { useCallback } from "react";

// Import issue fragment
gql(`
  fragment issue on Issue {
    level
    message
    key
    modelId
    modelName
    metadata
    jurisdictions
    schemaStack {
      model
      id
      name
    }
  }
`);

const VALIDATE_WASTE_STREAMS = gql(`
  query ValidateWasteStreams($wasteStreamIds: [ID!]!) {
    wasteStreamInputValidator(wasteStreamIds: $wasteStreamIds) {
      wasteStreamId
      issues {
        ...issue
      }
    }
  }
`);

export function useWasteStreamInputValidation() {
  const [query, { loading }] = useLazyQuery(VALIDATE_WASTE_STREAMS, {
    fetchPolicy: "no-cache",
  });

  const validate = useCallback(
    async (wasteStreamIds: string[]) => {
      if (wasteStreamIds.length === 0) {
        return [];
      }

      const { data, previousData } = await query({
        variables: {
          wasteStreamIds,
        },
      });

      return data
        ? data?.wasteStreamInputValidator
        : previousData?.wasteStreamInputValidator ?? [];
    },
    [query]
  );

  return { validate, loading };
}
